'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

exports["default"] = memoize;



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/is-prop-valid/~/@emotion/memoize/dist/emotion-memoize.cjs.prod.js
// module id = 368
// module chunks = 0